// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import apiPath from "../../shared/apiPath"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "SEI_ForecastSales"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [{
    key: "id",
    label: "编号",
    sortable: true,
  },
  {
    key: "dataAreaId",
    label: "销售公司",
    sortable: true
  },
  {
    key: "CompanyName",
    label: "销售公司名称",
    sortable: true,
    thStyle: {
      width: "12rem"
    },
    width: "12rem",
    type: "short"
  },
  {
    key: "CustAccountId",
    label: "客户帐户",
    sortable: true
  },
  {
    key: "ItemId",
    label: "物料编号",
    sortable: true
  },

  {
    key: "SalesQty",
    label: "销售数量",
    sortable: true,
    _precise: 6,
  },
  {
    key: "SalesPrice",
    label: "单位价格",
    sortable: true,
    _precise: 6,
  },
  {
    key: "Amount",
    label: "金额",
    sortable: true,
    _precise: 2,
  },
  {
    key: "ModelId",
    label: "模型",
    sortable: true
  },
  {
    key: "InventDimId",
    label: "维度编号",
    sortable: true
  },
  {
    key: "SEI_CP_ReplenishmentCommit",
    label: "补货计划",
    sortable: true
  },
  {
    key: "WeekName",
    label: "周的名称",
    sortable: true
  },
  {
    key: "Active",
    label: "有效",
    sortable: true
  },
  {
    key: "RetailVariantId",
    label: "款式编号",
    sortable: true,
  },
  {
    key: "ForecastSalesId",
    label: "预测订单编号",
    sortable: true,
  },
  {
    key: "ForecastLineNum",
    label: "预测订单行号",
    sortable: true,
  },
  {
    key: "is_valid",
    label: "状态",
    sortable: true,
    type: "state",
    context: ["禁用", "启用"]
  }
  ],
}

///前端验证
const rules = {}

const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
const methods = {
  //check

  //copacking
  async copackingMethod(json) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "GenerateCopackingSalesOrderForcast", {}, {}
    )
    let result = await code_biz_data
      .execAction({
        params: {
          json_ids: json
        },
        fields: []
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //信用同步
  async pickAndInvoke(params) {
    let query_settings = []
    _.each(params, t => {
      let _p = {
        company: t,
        tableName: "secp_SEI_CustTable2",
        accountNum: "", //不传则查询所有
      }
      query_settings.push({
        url: apiPath.axInterface.pickand_invoke,
        parameters: _p,
        method: "get"
      })
    })

    let data = await api.query_all_async(query_settings)

    if (data) {
      return data[0].result.data[0]
    } else {
      return false
    }
  },
  async SaveSaleOrderExport(json) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "generate_salesorder", {}, {}
    )
    let result = await code_biz_data
      .execAction({
        params: {
          json: json
        },
        fields: []
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },

  ///get copacking
  async getData(_params) {
    const get_biz_data = new biz_data_helper.base_entity_helper(
      "get_ForecastSales", {}, {}
    )
    let _fields = _.map(fields.default, "key")
    let result = await get_biz_data
      .execAction({
        params: _params,
        fields: _fields
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async updateCopackingData(items, state) {
    let batch_actions = []
    _.each(items, t => {
      batch_actions.push(
        biz_data.updateAction({
          params: { id: t.id, is_valid: state ? 1 : 0 },
          fields: ["id"]
        }).action({})
      )
    })
    let result = await api.query_batch({
      actions: batch_actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
}
export {
  biz_data, fields,
  methods,
  rules
};

